import { mergeFilters } from "helpers/reqparams";
import moment from "moment";
import React from "react";
import Datetime from "./datetime";

const DatetimeRange = (props) => {
    const { mergeParams, params, getList, name } = props;
    const { preparedFilter } = params;
    const date = params.customFilters[name]?.value || {};

    const changeDateFilter = (key, value) => {
        const previousValue = params.customFilters[name]?.value || {};

        let newValue;
        if (value) {
            newValue = { ...previousValue, [key]: moment(value).toDate() };
        } else {
            newValue = { ...previousValue };
            delete newValue[key];
        }

        params.start = 0;
        if (Object.keys(newValue).length) {
            params.customFilters[name] = { id: name, value: newValue, filterType: "dateTimeRange" };
            params.preparedFilter = { ...preparedFilter, and: { ...preparedFilter.and, [name]: newValue } };
        } else {
            delete params.customFilters[name];
            delete params.preparedFilter.and[name];
        }
        setTimeout(() => {
            mergeFilters(mergeParams, { name: "custom", value: null }, params);
        }, 0);
    };

    const forceUpdateList = () => {
        params.start = 0;
        if (!preparedFilter.and[name]) {
            params.preparedFilter = {
                ...preparedFilter,
                and: { ...preparedFilter.and, [name]: params.customFilters[name].value },
            };
        }
        mergeFilters(mergeParams, { name: "custom", value: null }, params);
        setTimeout(() => {
            getList(params);
        }, 0);
    };

    return (
        <div className="d-flex">
            <div className="col-form-label-sm">Период</div>
            <Datetime
                inPortal
                inputProps={{ name: "startAt" }}
                onChange={({ value }) => changeDateFilter("ge", value)}
                value={date.ge || ""}
                wrapper="pl-2 pr-2"
                bWrapper="d-inline-block"
            />
            <div className="col-form-label col-form-label-sm d-inline-block">&mdash;</div>
            <Datetime
                inPortal
                inputProps={{ name: "endAt" }}
                onChange={({ value }) => changeDateFilter("le", value)}
                value={date.le || ""}
                wrapper="pl-2 pr-2"
                bWrapper="d-inline-block"
            />
            <div className="btn btn-sm btn-brand" onClick={() => forceUpdateList()}>
                Обновить
            </div>
        </div>
    );
};

export default DatetimeRange;
